import { render } from "./AuthModal.vue?vue&type=template&id=1307a9e8&scoped=true"
import script from "./AuthModal.vue?vue&type=script&lang=js"
export * from "./AuthModal.vue?vue&type=script&lang=js"

import "./AuthModal.vue?vue&type=style&index=0&id=1307a9e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1307a9e8"

export default script